module.exports = __webpack_public_path__ + "static/media/34_A.834fcb59.png";